import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from '../../util/util.service';
import { LoanService } from '../../shared-component/service/loan/loan.service';
import {environment} from '../../../environments/environment';
import { WindowRefService } from '../terms-of-service/window.service';

@Component({
  selector: 'app-initial-payment',
  templateUrl: './initial-payment.component.html',
  styleUrls: ['./initial-payment.component.css']
})
export class InitialPaymentComponent implements OnInit {

  public loanDetail: any = {};
  public tokenId: string;
  public crd: any = {};
  public customerId: string;
  public rzp1: any;


  constructor(
    private activeRoute: ActivatedRoute,
    private utilService: UtilService,
    private loanService: LoanService,
    private winRef: WindowRefService,
    private zone: NgZone,
    private router: Router,
  
    
    
  ) { }

  ngOnInit() {
    this.utilService.getCurrentPosition(this);

    this.activeRoute.data.subscribe(res => {
      this.loanDetail = res.loanDetail;
      this.tokenId = this.loanDetail.token;
    });
    
    this.loanDetail.finalProcessingFee = 0;
    if (this.loanDetail.processingFee == Number(this.loanDetail.waiverProcessingFee).toFixed(2)) {
      this.loanDetail.finalProcessingFee = this.loanDetail.waiverProcessingFee === null ? 0 : this.loanDetail.waiverProcessingFee
    }

    this.loanDetail.finalAdvanceEMI = 0;
    if (this.loanDetail.systemAdvanceEmi == Number(this.loanDetail.waiverAdvanceToTCPL).toFixed(2)) {
      this.loanDetail.finalAdvanceEMI = Number(this.loanDetail.waiverAdvanceToTCPL).toFixed(2);
    }
    this.loanDetail.finalAmount = Number(this.loanDetail.finalProcessingFee) + Number(this.loanDetail.finalAdvanceEMI);
  }


  public optionsForInitialPayment: any = {
    name: environment.COMPANY_NAME,
    description: environment.PAYMENT_PROCESSING_FEE_DESCRIPTION,
    amount: 0,
    prefill: {
      name: '',
      email: ''
    },
    notes: {},
    theme: {
      color: '#3D3BEE'
    },
    handler: this.paymentResponseHandlerForInitialPayment.bind(this),
    modal: {
      ondismiss: (() => {
        this.zone.run(() => {
          this.router.navigateByUrl(`/loan/process/${this.tokenId}/enach`);
        });
      })
    }
  };

  async paymentResponseHandlerForInitialPayment(response: any) {
    let details = this.crd.data;
    this.zone.run(() => {
      let data = {
        paymentId: response.razorpay_payment_id,
        ...details
      };
      this.loanService.payment(this.tokenId,data).subscribe(() => {
        window.location.reload();
      });
    });
  }

  async initPay() {
    let details = this.crd.data; //await this.utilService.getDeviceDetails();
    let data: any = {
      customerId: this.customerId,
      ...details
    };
    this.loanService.getPaymentAmount(this.tokenId, data).subscribe((res: any) => {
      if (res.data.orderId) {
        this.optionsForInitialPayment.amount = res.data.amount;
        this.optionsForInitialPayment.order_id = res.data.orderId;
        this.optionsForInitialPayment.prefill.email = this.loanDetail.Customer.email;
        this.optionsForInitialPayment.prefill.name = this.loanDetail.Customer.fullName;
        this.optionsForInitialPayment.prefill.contact = this.loanDetail.Customer.mobile;
        this.optionsForInitialPayment.notes.applicationNumber = this.loanDetail.applicationNumber;
        this.optionsForInitialPayment.notes.type = 'Processing';
        this.optionsForInitialPayment.key = res.data.razorPayKey || environment.RAZOR_PAY_KEY;
        this.rzp1 = new this.winRef.nativeWindow['Razorpay'](this.optionsForInitialPayment);
        this.rzp1.open();
      } else {
        data.paymentId = true;
        this.loanService.payment(this.tokenId, data).subscribe(() => {
          window.location.reload();
        });
      }
    });
  }

}
